module.exports = __webpack_public_path__ + "img/full3-min.0c30a44c.png";